module.exports = "::ng-deep main {\n  /* Firefox */\n  /* Chrome, Safari */\n  height: calc(100vh - 100px); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contenedor.component.scss
// module id = ./src/app/components/contenedor.component.scss
// module chunks = main